import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import '../styles/PasswordReset.css';

const PasswordReset = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setMessage('');
      setError('');
      setLoading(true);
      
      await resetPassword(email);
      setMessage('Check your email for password reset instructions. The link will expire in 1 hour.');
    } catch (error) {
      console.error('Password reset error:', error);
      if (error.code === 'auth/user-not-found') {
        setError('No account found with this email address.');
      } else if (error.code === 'auth/invalid-email') {
        setError('Please enter a valid email address.');
      } else {
        setError('Failed to send password reset email. Please try again.');
      }
    }
    
    setLoading(false);
  };

  return (
    <div className="password-reset-container">
      <div className="password-reset-card">
        <img src="/images/connectional-logo.svg" alt="Connectional" className="reset-logo" />
        <h2>Reset Your Password</h2>
        <p className="reset-subtitle">Enter your email address and we'll send you a link to reset your password.</p>
        
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        
        <form onSubmit={handleSubmit} className="reset-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email address"
              disabled={loading}
            />
          </div>
          
          <button 
            type="submit" 
            disabled={loading}
            className="reset-btn"
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        
        <div className="reset-actions">
          <button 
            type="button" 
            onClick={onBack}
            className="back-btn"
            disabled={loading}
          >
            ← Back to Login
          </button>
        </div>
        
        <div className="reset-help">
          <p><strong>Need help?</strong></p>
          <p>If you don't receive the email within a few minutes, please check your spam folder or contact support at <a href="mailto:bom@twkumc.org">bom@twkumc.org</a></p>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
